module.exports = __webpack_public_path__ + "img/数据分析.3b1fff01.png";